namespace uh {
    export class App extends Phaser.Game {

        public static readonly ART_SCALE:number = 0.6;

        constructor() {
            let config:Phaser.Types.Core.GameConfig = {
                type: Phaser.AUTO,
                width: "100%",
                height: "100%",
                backgroundColor:0xFF0000,
                parent: 'game-container',
                dom: {
                    createContainer: true
                },
                scale: {
                    mode: Phaser.Scale.RESIZE,
                    autoCenter: Phaser.Scale.NO_CENTER
                },
                transparent: false,
                scene: {
                    create: () => {
                        this.scene.add('Boot', uh.scene.Boot, true);
                    }
                }
            };
            super(config);
        }
    }
}

function getLocale(id:string):string {
    let lang:object = window["-LOCALIZATION-"][window["-LANG-"]];
    if (lang && lang.hasOwnProperty(id)) return lang[id].toUpperCase();
    return "";
}

let game:uh.App;
window.onload = () => {
    game = new uh.App();
};